<template>
  <div>
    <h1>Collaborations</h1>
    <div class="my-16">
      <h2>
        <a href="https://typeqast.com/">
          Typeqast
        </a>
      </h2>
      <div class="my-8">
        <v-chip outlined class="mr-2 mb-2">Laravel</v-chip>
        <v-chip outlined class="mr-2 mb-2">Symfony</v-chip>
        <v-chip outlined class="mr-2 mb-2">Vue.js</v-chip>
      </div>
      <p class="my-8">
        Architecting and Developing ERP systems for International Clients,<br>
        as well as building internal apps for the Company.
      </p>
    </div>
    <div class="my-16">
      <h2>
        <a href="https://microblink.com/">
          Microblink
        </a>
      </h2>
      <div class="my-8">
        <v-chip outlined class="mr-2 mb-2">Spring Boot</v-chip>
        <v-chip outlined class="mr-2 mb-2">JavaScript</v-chip>
      </div>
      <p class="my-8">
        Building internal systems and public-facing apps<br>
        to support main operations of the Company.
      </p>
    </div>
    <div class="my-16">
      <h2>
        <a href="https://www.humaninteraction.com/">
          Human Interaction
        </a>
      </h2>
      <div class="my-8">
        <v-chip outlined class="mr-2 mb-2">Angular 2</v-chip>
        <v-chip outlined class="mr-2 mb-2">Node.js</v-chip>
        <v-chip outlined class="mr-2 mb-2">Symfony</v-chip>
      </div>
      <p class="my-8">
        Working on Frontend and Backend projects for Brands mainly from the SEE region.
      </p>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: "CollaborationsComponent",
});
</script>
